export default __webpack_public_path__ + "static/at-museum-icon-7433a994e1d384aa6ba6b064a4ebafa3.svg";